"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var getWixColor_1 = require("@wix/tpa-settings/dist/src/getWixColor");
var getWixFont_1 = require("@wix/tpa-settings/dist/src/getWixFont");
var StylesContext_types_1 = require("@wix/tpa-settings/dist/src/contexts/StylesContext/StylesContext.types");
var types_1 = require("./types");
var GroupsRequestBuilder_1 = require("@wix/social-groups-api/dist/src/model/GroupList/GroupsRequestBuilder");
var FontTheme_1 = require("@wix/social-groups-common/dist/src/settings/FontTheme");
exports.MAX_LAYOUT_SPACING = 100;
exports.DEFAULT_GRID_CARD_SPACING = 12;
exports.MAX_BUTTON_BORDER_RADIUS = 100;
exports.textSettings = {
    groupListTitle: {
        getDefaultValue: function () { return ''; },
        key: 'groupListTitle',
    },
    groupMembersLabel: {
        getDefaultValue: function () { return 'Members'; },
        key: 'groupMembersLabel',
    },
};
exports.displaySettings = {
    showHeaderTitle: {
        getDefaultValue: function () { return true; },
        key: 'showHeaderTitle',
    },
    showSearchSorting: {
        getDefaultValue: function () { return true; },
        key: 'showSearchSorting',
    },
    showMemberCount: {
        getDefaultValue: function () { return true; },
        key: 'showMemberCount',
    },
    showAdminBadge: {
        getDefaultValue: function () { return true; },
        key: 'showAdminBadge',
    },
    showImage: {
        getDefaultValue: function () { return true; },
        key: 'showImage',
    },
    mobileShowHeaderTitle: {
        getDefaultValue: function () { return true; },
        key: 'mobileShowHeaderTitle',
    },
    mobileShowSearchSorting: {
        getDefaultValue: function () { return true; },
        key: 'mobileShowSearchSorting',
    },
    mobileShowMemberCount: {
        getDefaultValue: function () { return true; },
        key: 'mobileShowMemberCount',
    },
    mobileShowAdminBadge: {
        getDefaultValue: function () { return true; },
        key: 'mobileShowAdminBadge',
    },
    mobileShowImage: {
        getDefaultValue: function () { return true; },
        key: 'mobileShowImage',
    },
};
exports.layoutSettings = {
    groupListLayout: {
        getDefaultValue: function () { return types_1.LayoutType.list; },
        key: 'groupListLayout',
    },
    mobileGroupListLayout: {
        getDefaultValue: function () { return types_1.LayoutType.list; },
        key: 'mobileGroupListLayout',
    },
    headerAlignment: {
        getDefaultValue: function () { return types_1.Alignment.left; },
        key: 'headerAlignment',
    },
    imageRatio: {
        getDefaultValue: function () { return types_1.ImageRatio.rectangle; },
        key: 'imageRatio',
    },
    mobileImageRatio: {
        getDefaultValue: function () { return types_1.ImageRatio.rectangle; },
        key: 'mobileImageRatio',
    },
    gridCardSpacing: {
        getDefaultValue: function () { return exports.DEFAULT_GRID_CARD_SPACING; },
        key: 'gridCardSpacing',
    },
    mobileGridCardSpacing: {
        getDefaultValue: function () { return exports.DEFAULT_GRID_CARD_SPACING; },
        key: 'mobileGridCardSpacing',
    },
    listCardSpacing: {
        getDefaultValue: function () { return 0; },
        key: 'listCardSpacing',
    },
    mobileListCardSpacing: {
        getDefaultValue: function () { return 0; },
        key: 'mobileListCardSpacing',
    },
};
exports.layoutStyles = (_a = {},
    _a[types_1.LayoutType.grid] = {
        cardSpacing: {
            name: 'groupCardGridSpacing',
            getDefaultValue: function () { return exports.DEFAULT_GRID_CARD_SPACING; },
            type: StylesContext_types_1.StyleParamType.Number,
        },
        mobileCardSpacing: {
            name: 'mobileGroupCardGridSpacing',
            getDefaultValue: function () { return exports.DEFAULT_GRID_CARD_SPACING; },
            type: StylesContext_types_1.StyleParamType.Number,
        },
        // TODO: do we really need this, seems like never used
        cardInnerSideSpacing: {
            getDefaultValue: function () { return 20; },
            name: 'groupCardGridInnerSideSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
        cardTopBottomSpacing: {
            getDefaultValue: function () { return 20; },
            name: 'groupCardGridTopBottomSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
        cardSideSpacing: {
            getDefaultValue: function () { return 20; },
            name: 'groupCardGridSideSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
    },
    _a[types_1.LayoutType.list] = {
        cardSpacing: {
            getDefaultValue: function () { return 12; },
            name: 'groupCardListSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
        mobileCardSpacing: {
            name: 'mobileGroupCardListSpacing',
            getDefaultValue: function () { return exports.DEFAULT_GRID_CARD_SPACING; },
            type: StylesContext_types_1.StyleParamType.Number,
        },
        // TODO: do we really need this, seems like never used
        cardInnerSideSpacing: {
            getDefaultValue: function () { return 20; },
            name: 'groupCardListInnerSideSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
        cardTopBottomSpacing: {
            getDefaultValue: function () { return 20; },
            name: 'groupCardListTopBottomSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
        cardSideSpacing: {
            getDefaultValue: function () { return 20; },
            name: 'groupCardListSideSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
    },
    _a[types_1.LayoutType.listWidget] = {
        cardSpacing: {
            getDefaultValue: function () { return 0; },
            name: 'groupCardListSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
        // TODO: do we really need this, seems like never used
        cardInnerSideSpacing: {
            getDefaultValue: function () { return 0; },
            name: 'groupCardListInnerSideSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
        cardTopBottomSpacing: {
            getDefaultValue: function () { return 20; },
            name: 'groupCardListTopBottomSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
        cardSideSpacing: {
            getDefaultValue: function () { return 0; },
            name: 'groupCardListSideSpacing',
            type: StylesContext_types_1.StyleParamType.Number,
        },
    },
    _a);
exports.designSettings = {
    buttonType: {
        getDefaultValue: function () { return types_1.ButtonType.rectangle; },
        key: 'buttonType',
    },
};
exports.designStyles = {
    text: {
        listTitle: {
            color: {
                name: 'listTitleColor',
                type: StylesContext_types_1.StyleParamType.Color,
                getDefaultValue: getWixColor_1.wixColorParam('black/white'),
            },
            font: {
                name: 'listTitleFont',
                type: StylesContext_types_1.StyleParamType.Font,
                getDefaultValue: getWixFont_1.wixFontParam(FontTheme_1.FontTheme.HEADING_2, {
                    size: 24,
                    htmlTag: 'h2',
                }),
            },
            mobileFontSize: {
                name: 'mobileListTitleFontSize',
                type: StylesContext_types_1.StyleParamType.Number,
                getDefaultValue: function () { return 20; },
            },
        },
        groupName: {
            color: {
                name: 'groupNameColor',
                type: StylesContext_types_1.StyleParamType.Color,
                getDefaultValue: getWixColor_1.wixColorParam('black/white'),
            },
            font: {
                name: 'groupNameFont',
                type: StylesContext_types_1.StyleParamType.Font,
                getDefaultValue: getWixFont_1.wixFontParam(FontTheme_1.FontTheme.HEADING_3, { size: 20 }),
            },
            mobileFontSize: {
                name: 'mobileGroupNameFontSize',
                type: StylesContext_types_1.StyleParamType.Number,
                getDefaultValue: function () { return 20; },
            },
        },
        colorOnHover: {
            name: 'groupNameColorOnHover',
            type: StylesContext_types_1.StyleParamType.Color,
            getDefaultValue: getWixColor_1.wixColorParam('color-8'),
        },
        searchSortingColor: {
            name: 'searchSortingColor',
            type: StylesContext_types_1.StyleParamType.Color,
            getDefaultValue: getWixColor_1.wixColorParam('black/white'),
        },
        groupInfo: {
            color: {
                name: 'groupInfoColor',
                type: StylesContext_types_1.StyleParamType.Color,
                getDefaultValue: getWixColor_1.wixColorParam('color-5'),
            },
            font: {
                name: 'groupInfoFont',
                type: StylesContext_types_1.StyleParamType.Font,
                getDefaultValue: getWixFont_1.wixFontParam(FontTheme_1.FontTheme.PARAGRAPH_2, { size: 14 }),
            },
            mobileFontSize: {
                name: 'mobileGroupInfoFontSize',
                type: StylesContext_types_1.StyleParamType.Number,
                getDefaultValue: function () { return 14; },
            },
        },
    },
    button: {
        color: {
            name: 'buttonColor',
            type: StylesContext_types_1.StyleParamType.Color,
            getDefaultValue: getWixColor_1.wixColorParam('color-8'),
        },
        background: {
            name: 'buttonBackground',
            type: StylesContext_types_1.StyleParamType.Color,
            getDefaultValue: getWixColor_1.wixColorParam('color-8'),
        },
        text: {
            color: {
                name: 'buttonTextColor',
                type: StylesContext_types_1.StyleParamType.Color,
                getDefaultValue: getWixColor_1.wixColorParam('white/black'),
            },
            font: {
                name: 'buttonTextFont',
                type: StylesContext_types_1.StyleParamType.Font,
                getDefaultValue: getWixFont_1.wixFontParam(FontTheme_1.FontTheme.PARAGRAPH_2),
            },
            mobileFontSize: {
                name: 'mobileButtonTextFontSize',
                type: StylesContext_types_1.StyleParamType.Number,
                getDefaultValue: function () { return 16; },
            },
        },
        borderRadius: {
            getDefaultValue: function () { return 100; },
            name: 'buttonBorderRadius',
            type: StylesContext_types_1.StyleParamType.Number,
        },
    },
    backgroundBorder: {
        card: {
            background: {
                color: {
                    name: 'cardBackgroundColor',
                    type: StylesContext_types_1.StyleParamType.Color,
                    getDefaultValue: getWixColor_1.wixColorParam('color-1'),
                },
            },
        },
        app: {
            background: {
                color: {
                    name: 'appBackgroundColor',
                    type: StylesContext_types_1.StyleParamType.Color,
                    getDefaultValue: getWixColor_1.wixColorParam('color-1'),
                },
            },
        },
        border: {
            color: {
                name: 'cardBorderColor',
                type: StylesContext_types_1.StyleParamType.Color,
                getDefaultValue: getWixColor_1.wixColorParam('color-5', 0.2),
            },
            width: {
                name: 'cardBorderWidth',
                type: StylesContext_types_1.StyleParamType.Number,
                getDefaultValue: function () { return 1; },
            },
        },
    },
};
exports.settingsSettings = {
    sortBy: {
        getDefaultValue: function () { return GroupsRequestBuilder_1.GroupsRequestSort.RECENT_ACTIVITY; },
        key: 'sortBy',
    },
};
//# sourceMappingURL=settings.js.map